// Import react libs
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Import style
import {
    FooterWrapper,
    LeftSection,
    RightSection,
    LegalLinks,
    ExternalLink,
    Icon,
    Logo,
} from './style';

// Import hooks
import { useFetchContactsInfos } from '../../utils/hooks/about';

// Import lib
import {
    formatInstagram,
    formatWhatsApp,
} from '../../utils/libs/socialNetworkLinkFormatter';

// Import assets
import logo from '../../assets/logos/logo.jpg';

import { ReactComponent as instagramIcon } from '../../assets/icons/instagram.svg';
import { ReactComponent as whatsappIcon } from '../../assets/icons/whatsapp.svg';

// Import texts
import footerTexts from '../../texts/footer';

function Footer({ LOGO_WIDTH = 50, ICON_WIDTH = 30 }) {
    // Get the contact informations
    const { data: contactsInfos } = useFetchContactsInfos();

    // Keep in a state the links to the socials networks
    const [instagramLink, setInstagramLink] = useState(null);
    const [whatsAppLink, setWhatsAppLink] = useState(null);

    // Update socials links every time contact infos change
    useEffect(() => {
        if (
            contactsInfos &&
            contactsInfos.instagram &&
            contactsInfos.instagram !== '' &&
            contactsInfos.whats_app &&
            contactsInfos.whats_app !== ''
        ) {
            setInstagramLink(formatInstagram(contactsInfos.instagram));
            setWhatsAppLink(formatWhatsApp(contactsInfos.whats_app));
        }
    }, [contactsInfos]);

    return (
        <FooterWrapper>
            <LeftSection>
                <LegalLinks to="/legal/legalnotices">
                    {footerTexts.legalNotices}
                </LegalLinks>
                <LegalLinks to="/legal/termesofuse">
                    {footerTexts.termesOfUse}
                </LegalLinks>
                <LegalLinks to="/legal/privacypolicy">
                    {footerTexts.privacyPolicy}
                </LegalLinks>
            </LeftSection>
            <RightSection>
                <ExternalLink
                    title={footerTexts.instagramIconTitle}
                    href={instagramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Icon as={instagramIcon} width={ICON_WIDTH} />
                </ExternalLink>
                <ExternalLink
                    title={footerTexts.whatsappIconTitle}
                    href={whatsAppLink}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Icon as={whatsappIcon} width={ICON_WIDTH} />
                </ExternalLink>
                <Link to="/">
                    <Logo
                        src={logo}
                        alt={footerTexts.logoAlt}
                        width={LOGO_WIDTH}
                        loading="lazy"
                    />
                </Link>
            </RightSection>
        </FooterWrapper>
    );
}

export default Footer;
